'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');

module.exports = getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixAccordionItem extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:accordion:active'];
        }

        connectedCallback() {
            super.connectedCallback();
            this.accordionId = this.getAttr('accordion-id', { required: true });
        }

        broadcastedEventCallback(name, args = {}) {
            const itemId = args.detail && args.detail.itemId;
            const accordionId = args.detail && args.detail.accordionId;

            if (accordionId !== this.accordionId) {
                return;
            }

            switch (name) {
                case 'phoenix:accordion:active':
                    if (this.id === itemId) {
                        this.classList.add('is-active');
                    } else {
                        this.classList.remove('is-active');
                    }
                    break;
            }
        }
    }
    window.customElements.define('phoenix-accordion-item', PhoenixAccordionItem);
});
